<template>
  <div>
    <!-- Campo de búsqueda -->
    <b-field label="Buscar">
      <b-input
        v-model="searchQuery"
        placeholder="Buscar..."
        type="search"
        icon-right-clickable
        expanded
        @icon-right-click="searchQuery = ''"
        @input="reloadSearch"
        @keydown.native.enter="loadAsyncData"
      >
      </b-input>

      <b-button @click="loadAsyncData" type="is-primary" class="ml-2"> Buscar </b-button>
    </b-field>

    <!-- Tabla -->
    <b-table
      :data="data"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :loading="loading"
      :per-page="perPage"
      :total="total"
      backend-pagination
      backend-sorting
      paginated
      @page-change="onPageChange"
      @sort="onSort"
      filters-change
      striped
    >
      <b-table-column field="id" label="#" sortable v-slot="props" width="80">
        {{ props.row.id }}
      </b-table-column>
      <b-table-column field="nombre" label="Nombre" sortable v-slot="props"> {{ props.row.nombre }} </b-table-column>
      <b-table-column field="acciones" label="Acciones" v-slot="props" width="80">
        <div class="buttons">
          <b-button @click="openModal(props.row)" type="is-primary" icon-left="eye" size="is-small" title="Ver"></b-button>
          <b-button @click="deleteRow(props.row.id)" type="is-danger" icon-left="delete" size="is-small" title="Eliminar"></b-button>
        </div>
      </b-table-column>
    </b-table>

    <div class="modal form-guests-modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Editar giro</h2>
          <button @click="closeForm()" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Form :key="formKey" :datavalues="formModalData" @close-form="closeForm"></Form>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Form from './form.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    Form,
  },
  data() {
    return {
      formKey: 0,
      data: [],
      total: 0,
      loading: false,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 20,
      searchQuery: '',
      showFormModal: false,
      formModalData: {},
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.loadAsyncData();
  },
  computed: {
    ...mapState({
      turns: (state) => state.externalTurns.list,
      pagination: (state) => state.externalTurns.pagination,
      reload: (state) => state.externalTurns.reloadList,
    }),
  },
  watch: {
    async reload(newValue) {
      if (newValue) {
        await this.loadAsyncData();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'externalTurns/fetchList',
      remove: 'externalTurns/remove',
    }),
    async loadAsyncData() {
      this.loading = true;

      const params = {
        page: this.page,
        size: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        search: this.searchQuery.toLowerCase(),
      };

      await this.fetchList(params);

      this.data = this.turns;
      this.total = this.pagination.total;

      this.loading = false;
      this.$store.commit('externalTurns/SET_DATA', { key: 'reloadList', data: false });
    },
    async onPageChange(page) {
      this.page = page;
      await this.loadAsyncData();
    },
    async onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      await this.loadAsyncData();
    },
    async reloadSearch() {
      if (this.searchQuery.length == 0) {
        await this.loadAsyncData();
      }
    },
    openModal(data) {
      this.formKey++;
      this.showFormModal = true;
      this.formModalData = data;
    },
    closeForm() {
      this.showFormModal = false;
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás recuperar este registro después de eliminarlo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        const response = await this.remove(id);

        Swal.fire({
          icon: response.status ? 'success' : 'error',
          title: response.message,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        await this.loadAsyncData();
      }
    },
  },
};
</script>
